import gsap from 'gsap';

import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { Basics, isMobile, isTouch, isWindows } from '../_app/cuchillo/core/Basics';
import Forms from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Cmp from '../windows/Cmp';
import { GetBy } from '../_app/cuchillo/core/Element';
import GridCanvas from '../components/GridCanvas';
import { Ease } from '../_app/cuchillo/utils/Ease';
import Scene from '../3D/Scene';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import Sidemenu from '../layout/Sidemenu';
import Header from '../layout/Header';

export default class Default extends Page {
  _contentWrapper;

  _calls = {
    sidemenuShow: () => {
      const left = isMobile ? '100%' : '75%';
      gsap.to(this._contentWrapper, { left, duration: .5, ease: Ease.EASE_CUCHILLO_IN_OUT });
    },
    sidemenuHide: () => {
      gsap.to(this._contentWrapper, { left: 0, duration: .75, ease: Ease.EASE_CUCHILLO_IN_OUT });
    }
  }

  constructor() {
    super();

    Videos.init();
    Acordions.init();
    Forms.init();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, Cmp._calls.click);
    });
  }

  //SHOW
  beforeShow() {
    super.beforeShow();
    Keyboard.mountPage(this.id);

    if (this.isFirstTime) {
      document.body.classList.toggle('__windows', isWindows);
      WebGLSketch.start();
    }

    this._contentWrapper = GetBy.class('__wrapper', this.container)[0];
    gsap.set(this._contentWrapper, { left: '100%' });

    Scroll.init(Scroll.AXIS_Y, { container: this._contentWrapper, domResize: this._contentWrapper, smooth: !isTouch, multiplicator: 1 });

    EventDispatcher.addEventListener(Sidemenu.ON_HIDE, this._calls.sidemenuHide, 'page-sidemenu');
    EventDispatcher.addEventListener(Sidemenu.ON_SHOW, this._calls.sidemenuShow, 'page-sidemenu');
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => {
          Header.show();
          GridCanvas.start();
          this.afterShow();
        });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.start();
    Scroll.show();

    gsap.killTweensOf(this._contentWrapper);
    gsap.to(this._contentWrapper, { left: 0, duration: 1, ease: Ease.EASE_CUCHILLO_IN_OUT });
  }

  //HIDE
  beforeHide() {
    Keyboard.unmountPage(this.id);
    super.beforeHide();

    gsap.killTweensOf(this._contentWrapper);
    gsap.to(this._contentWrapper, { left: '100%', duration: .6, ease: Ease.EASE_CUCHILLO_IN_OUT });

    EventDispatcher.removeEventListener(Sidemenu.ON_HIDE, 'page-sidemenu');
    EventDispatcher.removeEventListener(Sidemenu.ON_SHOW, 'page-sidemenu');
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Scroll.dispose();
    super.afterHide();
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('default', Default);
